<app-funnel-shell>
  <div class="funnel-card funnel-success">
    <div class="funnel-success__badge">✓</div>
    <h1>{{ 'funnel.success.title' | translate }}</h1>

    @if (productI18nKey(); as title) {
      <p class="funnel-card__intro">
        {{ 'funnel.success.intro_with_product' | translate: { product: (title | translate) } }}
      </p>
    } @else {
      <p class="funnel-card__intro">{{ 'funnel.success.intro' | translate }}</p>
    }

    <div class="funnel-success__next">
      <h2>{{ 'funnel.success.next_steps' | translate }}</h2>
      <ol class="funnel-success__steps">
        <li>{{ 'funnel.success.step_email' | translate }}</li>
        <li>{{ 'funnel.success.step_password' | translate }}</li>
      </ol>
    </div>

    @if (pwSent() !== null) {
      <div class="alert alert-success" role="alert">
        {{ 'funnel.success.password_resent' | translate: { email: pwSent() } }}
      </div>
    }
    @if (pwError()) {
      <div class="alert alert-danger" role="alert">
        {{ 'funnel.success.password_error' | translate }}
      </div>
    }

    <div class="funnel-success__actions">
      <button cButton color="primary" type="button" [disabled]="pwBusy()" (click)="goToPasswordSetup()">
        {{ (pwBusy() ? 'funnel.success.password_sending' : 'funnel.success.set_password') | translate }}
      </button>
    </div>
  </div>
</app-funnel-shell>
